export enum SortOrder {
  none = 0,
  ascending = 1,
  descending = 2,
  null = 3
}
